import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { routePath, routeNext, getUrl, formatCurrencyLabel } from "./helpers/Pipes";
/* Make sure that some pages CAN'T be accessed directly */
import { SubRoute } from "./helpers/MetaComponents";
/* Fase 1: Simulazione */
import { Page as SimulatorePage01 } from "./pages/01_Simulator";
import { Page as SimulatorePage02 } from "./pages/02_Loading";
import { Page as SimulatorePage03 } from "./pages/03_Recap";
/* Fase 2: Informazioni base */
import { Page as InfoBasePage01 } from "./pages/04_UserData";
import { Page as InfoBasePage02 } from "./pages/05_OTP";
/* Errori */
import { NotFoundPage } from "./pages/NotFoundPage/NotFoundPage";
import { Simulation } from "./hooks/simulationData";
import defaultSimulationJson from "./config/simulationDefault.json";
import "./assets/scss/app.scss";
import { useApi } from "./hooks/useApi";

export const App = () => {
  const navigate = useNavigate();
  const api = useApi();

    // Handle external params
    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());

    if (Object.keys(params).length > 0) {
      if (params.token) {
        Simulation.set("token", params.token);

        // save token in the applicat
        // if skipP1M is true, skip the speed flow
        if (params.skipP1M && params.skipP1M === "true") {
          api.logToGrafana("L'utente ha preferito continuare con il flusso standard", "200", {}, "skipP1M=true");
          return;
        }

        redirectToP1M(params.token);
      }      
    }
  }, []);

  const redirectToP1M = async (token) => {
    await api.logToGrafana("Tentativo di redirect alla pagina P1M", "200", {}, "token presente");
    api.goToP1M({ token }).then(async (res) => {
      if (res.isEnabled && res.isEnabled == true) {
        await api.logToGrafana("L'utente viene diretto alla pagina P1M", "200", {}, "utente abilitato");
        window.open(res.redirectUrl, "_self");
      }
      else {
        await api.logToGrafana("L'utente NON viene diretto alla pagina P1M", "200", {}, "utente NON abilitato");
      }
    });
  }

  const getImporto = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && params.importo) {
      return params.importo;
    }
    return Simulation.get("importo");
  }

  return (
    <>
      <Routes>
        <Route
          path={routePath("simulatore")}
          element={
            <SimulatorePage01
              sommaDefaultValue={getImporto()}
              sommaMinValue={defaultSimulationJson.importoMin}
              sommaMinValueLabel={formatCurrencyLabel(
                defaultSimulationJson.importoMin
              )}
              sommaMaxValue={defaultSimulationJson.importoMax}
              sommaMaxValueLabel={formatCurrencyLabel(
                defaultSimulationJson.importoMax
              )}
              sommaStep={defaultSimulationJson.importoStep}
              rataDefaultValue={Simulation.get("rata")}
              rataStep={defaultSimulationJson.rataStep}
              rataMaxValue={defaultSimulationJson.rataMax}
              rataMaxValueLabel={formatCurrencyLabel(
                Simulation.get("rataRangeMax")
              )}
              rataMinValue={defaultSimulationJson.rataMin}
              rataMinValueLabel={formatCurrencyLabel(
                Simulation.get("rataRangeMin")
              )}
              linkUrl={getUrl("ripresaBozza")}
              onNextRoute={() => {
                navigate(routePath(routeNext("simulatore")));
              }}
            />
          }
        />
        <Route
          path={routePath("loadingSimulazione")}
          element={
            <SubRoute>
              <SimulatorePage02
                onSimulationComplete={() => {
                  navigate(routePath(routeNext("loadingSimulazione")), {
                    replace: true,
                  });
                }}
              />
            </SubRoute>
          }
        />
        <Route
          path={routePath("risultatoSimulazione")}
          element={
            <SubRoute enableDirectAccess={true}>
              <SimulatorePage03
                onRedoSimulationClick={() => {
                  navigate(-1);
                }}
                onNextRoute={() => {
                  navigate(routePath(routeNext("risultatoSimulazione")));
                }}
              />
            </SubRoute>
          }
        />

        <Route
          path={routePath("inserisciTelefono")}
          element={
            <SubRoute>
              <InfoBasePage01
                onNextRoute={() => {
                  navigate(routePath(routeNext("inserisciTelefono")));
                }}
              />
            </SubRoute>
          }
        />
        <Route
          path={routePath("inserisciOTP")}
          element={
            <SubRoute>
              <InfoBasePage02
                onNextRoute={() => {
                  window.location.href = routeNext("inserisciOTP");
                }}
              />
            </SubRoute>
          }
        />

                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </>
    );
};
